// backport from AngularJS (webroot/_ui/desktop/common/js/angular/controllers/accountAddressBookController.js)
import spinner from '../utils/rbata.spinner';
import logger from '../utils/rbata.logger';
import urlService from '../services/rbata.urlService';
import formSelect from '../forms/rbata.select';

const addressManagement = {
    $body:                 undefined,
    $addAddressButton:     undefined,
    $addressFormContainer: undefined,
    $addressBook:          undefined,
    tempAddressId:         '',
    init() {
        this.$body                 = $('body');
        this.$addAddressButton     = $('.js-add-button-wrapper');
        this.$addressFormContainer = $('#js-address-form__container');
        this.$addressBook          = $('#js-address-item__list');
        this.bindEvents();
        this.bindToolTips();
    },
    showAddAddressFrom() {
        spinner.visibility(true);
        $.ajax({
            url:    `${urlService.getBaseUrl()}my-account/add-address/`,
            method: 'GET',
            cache:  false
        }).done((response) => {
            this.insertAddressForm(response);
        }).fail((jqXHR, textStatus, errorThrown) => {
            logger.error(`${jqXHR.status} error in addressManagement.showAddAddressFrom`)
        }).always(() => {
            spinner.visibility(false);
        });
    },
    submitForm(editMode) {
        const $form     = $('#js-address-form');
        const addressId = $('#js-address-id').val();
        let url         = '';

        if (editMode === 'true') {
            url = `${urlService.getBaseUrl()}my-account/edit-address/${addressId}`;
        } else {
            url = `${urlService.getBaseUrl()}my-account/add-address`;
        }

        spinner.visibility(true);
        $.ajax({
            url:         url,
            method:      'POST',
            data:        $form.serialize(),
            contentType: 'application/x-www-form-urlencoded'
        }).done((response) => {
            this.renderFormResponse(response);
        }).fail((jqXHR, textStatus, errorThrown) => {
            logger.error(`${jqXHR.status} error in addressManagement.submitForm`)
        }).always(() => {
            spinner.visibility(false);
        });
    },

    insertAddressForm(data) {
        this.$addAddressButton.hide();
        this.$addressFormContainer.html($(data).find('#js-address-form__section').html());
        formSelect.buildSelectMenu();
    },

    renderFormResponse(data) {
        const errorOccured = !!$(data).find('#js-address-form').length;

        if (errorOccured) {
            // form was invalid. rerender the new form
            this.insertAddressForm(data);
        } else {
            // success. remove form and show the new address book
            this.removeAddressForm();
            this.exchangeAddressBook(data);
            this.renderSuccessMessage(data, this.tempAddressId);
            this.tempAddressId = '';
        }
    },
    exchangeAddressBook(data) {
        const newAddressBook = $(data).find('#js-address-item__list').html();

        this.$addressBook.html(newAddressBook);
        this.bindToolTips();
    },
    removeAddressForm() {
        this.$addAddressButton.show();
        this.$addressFormContainer.empty();
    },
    renderSuccessMessage(data, addressId) {
        const $globalMsg = $(data).find('#globalMessages');
        const msg        = $globalMsg.find('.message__text').html()

        if ($globalMsg.html() === '') {
            return;
        }

        if (addressId === '') {
            // Fallback for add new address
            addressId = $globalMsg.find('#new-address-id')[0].dataset.id;
        }

        const $changedAddress = $('#js-address-' + addressId);
        $changedAddress.addClass('content-box--message-feedback');
        $changedAddress.find('.message--address').removeClass('d-none');
        $changedAddress.find('.js-message__text').html(msg);

        $('html, body').animate({
            scrollTop: $changedAddress.offset().top - 150
        }, 350);
    },
    deleteAddress(addressId) {
        // hide (remove) edit form. User could delete and edit an address in the same time
        this.removeAddressForm();

        spinner.visibility(true);
        $.ajax({
            url:    `${urlService.getBaseUrl()}my-account/remove-address/${addressId}`,
            method: 'GET',
            cache:  false
        }).done((response) => {
            this.exchangeAddressBook(response);
        }).fail((jqXHR, textStatus, errorThrown) => {
            logger.error(`${jqXHR.status} error in addressManagement.deleteAddress`);
        }).always(() => {
            spinner.visibility(false);
        });
    },
    editAddress(addressId) {
        spinner.visibility(true);
        $.ajax({
            url:    `${urlService.getBaseUrl()}my-account/edit-address/${addressId}`,
            method: 'GET',
            cache:  false
        }).done((response) => {
            this.insertAddressForm(response);
            $('html, body').animate({
                scrollTop: this.$addressFormContainer.offset().top - 150
            }, 350);
            this.tempAddressId = addressId;
        }).fail((jqXHR, textStatus, errorThrown) => {
            logger.error(`${jqXHR.status} error in addressManagement.editAddress`);
        }).always(() => {
            spinner.visibility(false);
        });
    },

    changeDefaultAddress(addressId) {
        spinner.visibility(true);
        $.ajax({
            url:    `${urlService.getBaseUrl()}my-account/set-default-address/${addressId}`,
            method: 'GET',
            cache:  false
        }).done((response) => {
            this.exchangeAddressBook(response);
            this.renderSuccessMessage(response, addressId);
        }).fail((jqXHR, textStatus, errorThrown) => {
            logger.error(`${jqXHR.status} error in addressManagement.changeDefaultAddress`);
        }).always(() => {
            spinner.visibility(false);
        });
    },
    tooltipTemplate(title, confirm, cancel, addressId) {
        return `<div class="mb-2">${title}</div>
            <div class="tooltip-buttons">
                <button type="button" class="js-tooltip-cancel btn btn-secondary btn-inverse btn-sm">${cancel}</button>
                &nbsp;
                <button type="button" class="js-tooltip-confirm btn btn-primary btn-inverse btn-sm" data-id="${addressId}">${confirm}</button>
            </div>`;
    },
    bindEvents() {
        this.$body.on('click', '#js-show-add-address-form', (evt) => {
            evt.preventDefault();
            this.showAddAddressFrom();
        });
        this.$body.on('click', '#js-submit-form', (evt) => {
            evt.preventDefault();
            this.submitForm(evt.currentTarget.dataset.edit);
        });
        this.$body.on('click', '.js-remove-address-form', (evt) => {
            evt.preventDefault();
            this.removeAddressForm();
        });
        this.$body.on('click', '.js-delete-address', (evt) => {
            evt.preventDefault();
            this.deleteAddress(evt.currentTarget.dataset.id);
        });
        this.$body.on('click', '.js-request-delete-address', (evt) => {
            evt.preventDefault();
            $(evt.currentTarget).tooltip('show');
        });
        this.$body.on('click', '.js-edit-address', (evt) => {
            evt.preventDefault();
            this.editAddress(evt.currentTarget.dataset.id);
        });
        this.$body.on('click', '.js-change-default-address', (evt) => {
            evt.preventDefault();
            this.changeDefaultAddress(evt.currentTarget.dataset.id);
        });
        this.$body.on('click', '.js-tooltip-confirm', (evt) => {
            evt.preventDefault();
            this.deleteAddress(evt.currentTarget.dataset.id);
        });
        this.$body.on('click', '.js-tooltip-cancel', (evt) => {
            evt.preventDefault();
            $('#js-address-item__list').find('.js-request-delete-address').tooltip('hide');
        });
    },
    bindToolTips() {
        const $eraseDefaultAddress = $('.js-request-delete-address');
        $eraseDefaultAddress.tooltip({
            html:      true,
            sanitize:  false,
            container: '.address-item--default',
            title:     addressManagement.tooltipTemplate(
                    $eraseDefaultAddress.data('tooltip-title'),
                    $eraseDefaultAddress.data('tooltip-confirm'),
                    $eraseDefaultAddress.data('tooltip-cancel'),
                    $eraseDefaultAddress.data('id')
            ),
            placement: 'top',
            trigger:   'manual'
        });
    },
};

$(() => {
    if ($('#address-book-page')) {
        addressManagement.init();
    }
});
export default addressManagement;
